import { DelayReason } from '../../../../../entities/DelayReason';
import { Actions } from './actions';
import {
  DELETE_DELAY_REASON_REQUEST,
  GET_DELAY_REASONS_ERROR,
  GET_DELAY_REASONS_REQUEST,
  GET_DELAY_REASONS_SUCCESS,
  SAVE_DELAY_REASON_REQUEST,
} from './constants';

const initialState = {
  delayReasons: [] as DelayReason[],
  loading: false,
  error: null as Error | null,
};

type DelayReasonsState = typeof initialState;

export const delayReasonsTabReducer = (state: DelayReasonsState = initialState, action: Actions): DelayReasonsState => {
  switch (action.type) {
    case GET_DELAY_REASONS_REQUEST:
    case SAVE_DELAY_REASON_REQUEST:
    case DELETE_DELAY_REASON_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_DELAY_REASONS_SUCCESS:
      return { ...state, loading: false, error: null, delayReasons: action.payload.delayReasons };
    case GET_DELAY_REASONS_ERROR:
      return { ...state, loading: false, error: action.payload.error };
    default:
      return state;
  }
};
